import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { ProblemSection } from '@/components/ProblemSection';
import { FounderSection } from '@/components/FounderSection';
import { TestimonialsSection } from '@/components/TestimonialsSection';
import { ComparisonSection } from '@/components/ComparisonSection';
import { Footer } from '@/components/Footer';

// Lazy load below-the-fold heavy components to reduce initial bundle size
const SpeedTestSection = lazy(() => import('@/components/SpeedTestSection').then(m => ({ default: m.SpeedTestSection })));
const PricingSection = lazy(() => import('@/components/PricingSection').then(m => ({ default: m.PricingSection })));

// Simple loading fallback
const SectionLoader = () => (
  <div className="py-24 lg:py-32 flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Trade Websites South Wales | SmartSite Solutions</title>
        <meta name="description" content="Based in North Cornelly, we engineer fast, SEO-optimised React websites for plumbers, builders and trades across Cardiff, Swansea, Newport and Bridgend. Get more leads today." />
        <link rel="canonical" href="https://smartsite-lead-gen.lovable.app/" />
      </Helmet>
      <Navbar />
      <main role="main" aria-label="Homepage content">
        <Hero />
        <ProblemSection />
        <FounderSection />
        <TestimonialsSection />
        <ComparisonSection />
        <Suspense fallback={<SectionLoader />}>
          <SpeedTestSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <PricingSection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
